import { StockProduct } from '../models/products/stock-product';
import { httpPost } from './http';

const apiUrl = 'api/products';

export const updateProductBarcode = (id: number, barCode: string) => httpPost<StockProduct>(`${apiUrl}/updatebarcode`, { id, barCode });
